import { render, staticRenderFns } from "./PcmPagination.vue?vue&type=template&id=a35b1b8c&scoped=true&"
import script from "./PcmPagination.vue?vue&type=script&lang=ts&"
export * from "./PcmPagination.vue?vue&type=script&lang=ts&"
import style0 from "./PcmPagination.vue?vue&type=style&index=0&id=a35b1b8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35b1b8c",
  null
  
)

export default component.exports